var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanderaRoja(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 199.65 910.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-4);\r\n        mix-blend-mode: multiply;\r\n        opacity: .35;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -7881.48,
    y1: 455.46,
    x2: -7681.83,
    y2: 455.46,
    gradientTransform: "translate(-7681.83) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#920000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#c90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -8076.63,
    y1: 797.72,
    x2: -7680.03,
    y2: 110.79,
    gradientTransform: "translate(-7681.83) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#927f47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c6bc9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#927f47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 11500.87,
    y1: 794.39,
    x2: 11106.88,
    y2: 111.99,
    gradientTransform: "translate(-11299.95)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -7781.21,
    y1: 89.28,
    x2: -7781.21,
    y2: 0,
    gradientTransform: "translate(7880.59 89.28) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#edecec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#bebbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#746e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#453e3e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m0,910.39s74.14-73.09,98.85-73.09,100.8,73.09,100.8,73.09V.53S0,.53,0,.53v909.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "199.65 .53 189.18 .53 189.18 900.75 199.65 910.39 199.65 .53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 .53 10.47 .53 10.47 900.75 0 910.39 0 .53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0,
    y: 0,
    width: 198.76,
    height: 89.28,
    transform: "translate(198.76 89.28) rotate(-180)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanderaRoja);
export default __webpack_public_path__ + "static/media/bandera-roja.dbdc553aeb07a0e1717b6262d25ff839.svg";
export { ForwardRef as ReactComponent };